(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Money ---------------------------------------------------------------- */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '£{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* Toast ---------------------------------------------------------------- */
  var toastTimer;
  function toast(message) {
    var el = $('#Toast');
    if (!el) return;
    $('.toast__text', el).textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* Cart count ----------------------------------------------------------- */
  function refreshCartCount() {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        $$('.header__basket').forEach(function (el) { el.setAttribute('aria-label', 'Basket, ' + cart.item_count + ' items'); });
      })
      .catch(function () {});
  }

  /* AJAX add to basket --------------------------------------------------- */
  function addToCart(form) {
    var button = $('[type="submit"][name="add"]', form) || $('[type="submit"]', form);
    var errorEl = $('.js-form-error', form);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || theme.strings.error;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { toast(msg); }
          return;
        }
        toast(theme.strings.added);
        refreshCartCount();
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = theme.strings.error; errorEl.hidden = false; } else { toast(theme.strings.error); }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          if (!button.dataset.soldOut) button.disabled = false;
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !(form.classList.contains('js-ajax-add') || form.classList.contains('js-product-form'))) return;
    if (e.submitter && e.submitter.name !== 'add' && e.submitter.type === 'submit' && form.classList.contains('js-product-form')) return;
    e.preventDefault();
    addToCart(form);
  });

  /* Drawers (menu) ------------------------------------------------------- */
  $$('.js-drawer').forEach(function (drawer) {
    drawer.addEventListener('toggle', function () {
      document.body.classList.toggle('no-scroll', drawer.open);
    });
    $$('.js-drawer-close', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () { drawer.open = false; $('summary', drawer).focus(); });
    });
  });

  /* Dropdowns ------------------------------------------------------------ */
  var dropdowns = $$('.js-dropdown');
  dropdowns.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
  document.addEventListener('click', function (e) {
    dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    dropdowns.forEach(function (d) { if (d.open) { d.open = false; $('summary', d).focus(); } });
    $$('.js-drawer[open]').forEach(function (d) { d.open = false; });
    closeFacets();
  });

  /* Scroll-snap slider helper ------------------------------------------- */
  function indexOf(track) {
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }
  function goTo(track, i) {
    var count = track.children.length;
    if (i < 0) i = count - 1;
    if (i >= count) i = 0;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* Hero slider ---------------------------------------------------------- */
  $$('.js-slider').forEach(function (slider) {
    var track = $('.js-slider-track', slider);
    var current = $('.js-slider-current', slider);
    if (!track) return;
    var prev = $('.js-slider-prev', slider);
    var next = $('.js-slider-next', slider);
    if (prev) prev.addEventListener('click', function () { goTo(track, indexOf(track) - 1); });
    if (next) next.addEventListener('click', function () { goTo(track, indexOf(track) + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { if (current) current.textContent = indexOf(track) + 1; });
    });

    var autoplay = slider.dataset.autoplay === 'true' && !reduceMotion && track.children.length > 1;
    if (!autoplay || window.Shopify && window.Shopify.designMode) return;
    var speed = parseInt(slider.dataset.speed, 10) || 6000;
    var timer = null;
    function start() { stop(); timer = setInterval(function () { goTo(track, indexOf(track) + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    start();
  });

  /* Quantity steppers ---------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty-minus, .js-qty-plus');
    if (!btn) return;
    var input = $('.qty__input', btn.closest('.qty'));
    if (!input) return;
    var min = parseInt(input.min, 10) || 0;
    var value = parseInt(input.value, 10) || 0;
    value = btn.classList.contains('js-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: submit after a quantity change --------------------------- */
  var cartForm = $('#CartForm');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.classList.contains('js-cart-qty')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        cartForm.appendChild(hidden);
        cartForm.submit();
      }, 500);
    });
  }

  /* Collection filters --------------------------------------------------- */
  var facets = $('.js-facets');
  function openFacets() {
    if (!facets) return;
    facets.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var close = $('.js-facets-close', facets);
    if (close) close.focus();
  }
  function closeFacets() {
    if (!facets || !facets.classList.contains('is-open')) return;
    facets.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    var opener = $('.js-facets-open');
    if (opener) opener.focus();
  }
  $$('.js-facets-open').forEach(function (b) { b.addEventListener('click', openFacets); });
  $$('.js-facets-close').forEach(function (b) { b.addEventListener('click', closeFacets); });

  var facetsForm = $('.js-facets-form');
  if (facetsForm) {
    var facetTimer;
    facetsForm.addEventListener('change', function (e) {
      if (!desktop.matches) return;
      clearTimeout(facetTimer);
      var delay = e.target.type === 'number' ? 700 : 0;
      facetTimer = setTimeout(function () { submitFacets(); }, delay);
    });
    facetsForm.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
  }
  function submitFacets() {
    var params = new URLSearchParams(new FormData(facetsForm));
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    window.location.href = facetsForm.action + '?' + clean.toString();
  }

  $$('.js-sort-select').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* Product page --------------------------------------------------------- */
  $$('.js-product').forEach(function (root) {
    var track = $('.js-gallery-track', root);
    var galleryCurrent = $('.js-gallery-current', root);
    var thumbs = $$('.js-gallery-thumb', root);

    function setActiveThumb(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (galleryCurrent) galleryCurrent.textContent = i + 1;
    }
    function goToMedia(mediaId) {
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
      if (i > -1) goTo(track, i);
    }

    if (track) {
      var gRaf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(gRaf);
        gRaf = requestAnimationFrame(function () { setActiveThumb(indexOf(track)); });
      });
      var gp = $('.js-gallery-prev', root), gn = $('.js-gallery-next', root);
      if (gp) gp.addEventListener('click', function () { goTo(track, indexOf(track) - 1); });
      if (gn) gn.addEventListener('click', function () { goTo(track, indexOf(track) + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goToMedia(t.dataset.mediaId); }); });
      var active = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (active > 0) requestAnimationFrame(function () { track.scrollLeft = active * track.clientWidth; });
    }

    var form = $('.js-product-form', root);
    var idInput = form && $('.js-variant-id', form);
    var addBtn = $('.js-add-button', root);
    var addLabel = $('.js-add-label', root);
    var picker = $('.js-variant-picker', root);
    var sticky = $('.js-sticky-buy');
    var stickyBtn = sticky && $('.js-sticky-add', sticky);
    var stickyPrice = sticky && $('.js-sticky-price', sticky);

    function setAvailability(available, exists) {
      var label = !exists ? theme.strings.unavailable : available ? theme.strings.addToBasket : theme.strings.soldOut;
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        if (available) delete b.dataset.soldOut; else b.dataset.soldOut = 'true';
      });
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.textContent = label;
    }

    if (picker && form) {
      var variants = [];
      try { variants = JSON.parse($('.js-variants-json', picker).textContent); } catch (err) {}
      var fieldsets = $$('fieldset', picker);

      function selectedOptions() {
        return fieldsets.map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
      }
      function markUnavailable(selected) {
        fieldsets.forEach(function (fs, idx) {
          $$('.pill', fs).forEach(function (pill) {
            var val = $('input', pill).value;
            var possible = variants.some(function (v) {
              if (!v.available || v.options[idx] !== val) return false;
              return selected.every(function (s, j) { return j === idx || s === null || v.options[j] === s; });
            });
            pill.classList.toggle('is-unavailable', !possible);
          });
        });
      }

      picker.addEventListener('change', function (e) {
        var fs = e.target.closest('fieldset');
        if (fs) { var lbl = $('.js-option-selected', fs); if (lbl) lbl.textContent = e.target.value; }
        var selected = selectedOptions();
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        markUnavailable(selected);

        if (!variant) { setAvailability(false, false); return; }
        idInput.value = variant.id;
        setAvailability(variant.available, true);

        $$('[data-price]', root).forEach(function (p) {
          var cur = $('[data-price-current]', p);
          var cmp = $('[data-price-compare]', p);
          if (cur) cur.textContent = formatMoney(variant.price);
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (cmp) { cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !onSale; }
          var sav = p.querySelector('[data-price-saving]');
          if (sav) {
            sav.textContent = onSale ? 'Save ' + formatMoney(variant.compare_at_price - variant.price) : '';
            sav.hidden = !onSale;
          }
          p.classList.toggle('price--on-sale', !!onSale);
        });
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        var stockLine = $('.js-stock-line', root);
        if (stockLine) {
          var p2 = stockLine.querySelector('p');
          if (p2) {
            if (!variant.available) {
              p2.className = 'stock-line muted';
              p2.textContent = 'Out of stock';
            } else if (variant.inventory_management && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity <= (window.theme.lowStock || 0)) {
              p2.className = 'stock-line stock-line--low';
              p2.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
            } else {
              p2.className = 'stock-line stock-line--in';
              p2.textContent = 'In stock, ready to send';
            }
          }
        }
        if (variant.featured_media) goToMedia(variant.featured_media.id);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
      markUnavailable(selectedOptions());
    }

    /* Sticky add to basket on mobile */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      });
      io.observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addToCart(form);
      });
    }
  });


  /* Collection tabs ------------------------------------------------------ */
  $$('.js-tabs').forEach(function (root) {
    var tabs = $$('.js-tab', root);
    var panels = $$('.js-tab-panel', root);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
      });
    });
  });

  /* Countdown ------------------------------------------------------------ */
  $$('.js-countdown').forEach(function (el) {
    var end = new Date((el.dataset.end || '').replace(' ', 'T'));
    if (isNaN(end.getTime())) return;
    var out = {
      days: $('.js-cd-days', el), hours: $('.js-cd-hours', el),
      mins: $('.js-cd-mins', el), secs: $('.js-cd-secs', el)
    };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = end - new Date();
      if (diff <= 0) {
        el.classList.add('is-expired');
        var label = $('.countdown__label', el);
        if (label) label.textContent = el.dataset.expiredText || '';
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      out.days.textContent = pad(Math.floor(s / 86400));
      out.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      out.mins.textContent = pad(Math.floor(s % 3600 / 60));
      out.secs.textContent = pad(s % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* Recently viewed ------------------------------------------------------ */
  var RV_KEY = 'cornerstock:recently-viewed';
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  var productRoot = $('.js-product');
  if (productRoot && productRoot.dataset.url) {
    try {
      var list = readRecent().filter(function (u) { return u !== productRoot.dataset.url; });
      list.unshift(productRoot.dataset.url);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  $$('.js-recently-viewed').forEach(function (section) {
    var grid = $('.js-recently-viewed-grid', section);
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var urls = readRecent().filter(function (u) { return !productRoot || u !== productRoot.dataset.url; }).slice(0, limit);
    if (!urls.length) return;
    Promise.all(urls.map(function (url) {
      return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).map(function (h) { return '<li>' + h.trim() + '</li>'; }).join('');
      if (!html) return;
      grid.innerHTML = html;
      section.hidden = false;
    });
  });

  /* Product recommendations --------------------------------------------- */
  $$('.js-product-recs').forEach(function (el) {
    if (el.children.length && el.querySelector('.card')) return;
    var url = el.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.js-product-recs');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
